var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardArrowRight = function SvgKeyboardArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.6,
    d: "M7.742 13.233 10.975 10 7.742 6.766a.83.83 0 1 1 1.175-1.175l3.825 3.825a.83.83 0 0 1 0 1.175l-3.825 3.825a.83.83 0 0 1-1.175 0 .85.85 0 0 1 0-1.183"
  })));
};
export default SvgKeyboardArrowRight;